import type { SVGProps } from 'react';

export const AddToWatchlistIcon = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path d="M3 1H1V3H3V1Z" fill="currentColor" />
    <path d="M3 5H1V7H3V5Z" fill="currentColor" />
    <path d="M1 9H3V11H1V9Z" fill="currentColor" />
    <path d="M3 13H1V15H3V13Z" fill="currentColor" />
    <path d="M15 1H5V3H15V1Z" fill="currentColor" />
    <path d="M15 5H5V7H15V5Z" fill="currentColor" />
    <path d="M5 9H7.5V11H5V9Z" fill="currentColor" />
    <path d="M7.5 13H5V15H7.5V13Z" fill="currentColor" />
    <path
      d="M12.8571 9H11.1429V11.1429L9 11.1429V12.8571H11.1429V15H12.8571V12.8571H15V11.1429L12.8571 11.1429V9Z"
      fill="currentColor"
    />
  </svg>
);
